export const geojsonIoLink = (data) => {
    return `http://geojson.io/#data=data:application/json,${encodeURI(JSON.stringify(data))}`
}